module.exports = __webpack_public_path__ + "img/x.70d8f04f.svg";